import * as React from 'react';

import { Flex, Input, Typography } from 'antd';

type PaymentGatewaysHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
};

const PaymentGatewaysHeader = ({
  searchKey,
  handleSearchKey,
}: PaymentGatewaysHeaderProps) => (
  <Flex
    gap='middle'
    className='mb-5 max-lg:flex-col lg:items-center lg:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-nowrap text-lg'>
      درگاه‌های پرداخت
    </Typography.Title>
    <Input.Search
      allowClear
      className='basis-full lg:basis-96'
      styles={{
        affixWrapper: {
          height: '2.5rem',
        },
      }}
      placeholder='جستجوی درگاه‌های پرداخت'
      defaultValue={searchKey}
      onSearch={value => handleSearchKey(value)}
    />
  </Flex>
);

export { PaymentGatewaysHeader };
